import { Action, createReducer, on } from '@ngrx/store';
import { IConfigState } from './config';
import { Config } from '../../interfaces/config';
import {
  ADD_TOAST_NOTIFICATION,
  RETRIEVE_CONFIG_SUCCESS,
  RETRIVE_CATALOGO_APPARTENENZA_SUCCESS,
  RETRIVE_CLASSE_APPARTENENZA_SUCCESS,
  RETRIVE_COMUNI_SUCCESS,
  RETRIVE_PROVINCE_SUCCESS,
  RETRIVE_REGIONI_SUCCESS,
} from './config.actions';
import { INotification } from '../../interfaces/notification';
import { IComuni, IProvince, IRegioni } from '../../interfaces/location';
import { IDropdownOptions } from '@poste-click-connect/shared-ui';

/* INITIAL STATE */
const initialState: IConfigState = {
  notificationMessage: null,
  catalogoAppartenenza: [],
  classeAppartenenza: [],
};

const handleSaveConfig = (
  state: IConfigState,
  { config }: { config: Config }
): IConfigState => {
  return {
    ...state,
    ...config,
  };
};

const handleAddToastNotification = (
  state: IConfigState,
  { notificationMessage }: { notificationMessage: INotification | null }
): IConfigState => {
  return {
    ...state,
    notificationMessage,
  };
};

const handleRetriveRegioni = (
  state: IConfigState,
  { regioni }: { regioni: IRegioni }
): IConfigState => {
  return {
    ...state,
    regioni,
  };
};

const handleRetriveProvince = (
  state: IConfigState,
  { province }: { province: IProvince | null }
): IConfigState => {
  return {
    ...state,
    province,
  };
};

const handleRetriveComuni = (
  state: IConfigState,
  { comuni }: { comuni: IComuni | null }
): IConfigState => {
  return {
    ...state,
    comuni,
  };
};

const handleRetrieveCatalogoAppartenenza = (
  state: IConfigState,
  { catalogoAppartenenza }: { catalogoAppartenenza: IDropdownOptions<any>[] }
): IConfigState => {
  return {
    ...state,
    catalogoAppartenenza,
  };
};

const handleRetrieveClasseAppartenenza = (
  state: IConfigState,
  { classeAppartenenza }: { classeAppartenenza: IDropdownOptions<any>[] | [] }
): IConfigState => {
  return {
    ...state,
    classeAppartenenza,
  };
};

/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(RETRIEVE_CONFIG_SUCCESS, handleSaveConfig),
  on(ADD_TOAST_NOTIFICATION, handleAddToastNotification),
  on(RETRIVE_REGIONI_SUCCESS, handleRetriveRegioni),
  on(RETRIVE_PROVINCE_SUCCESS, handleRetriveProvince),
  on(RETRIVE_COMUNI_SUCCESS, handleRetriveComuni),
  on(RETRIVE_CATALOGO_APPARTENENZA_SUCCESS, handleRetrieveCatalogoAppartenenza),
  on(RETRIVE_CLASSE_APPARTENENZA_SUCCESS, handleRetrieveClasseAppartenenza)
);

export const configReducer = (
  state: IConfigState | undefined,
  action: Action
): IConfigState => reducer(state, action);
